import axios from 'axios';
import { toast } from 'react-toastify'; // eslint-disable-next-line
import config from '../config/config'; // eslint-disable-next-line
import masonic_craft_gldc from '../../assets/img/lodges/masonic_craft_gldc.png';
import masonic_craft_glny from '../../assets/img/lodges/masonic_craft_glny.png';
import masonic_craft_glnj from '../../assets/img/lodges/masonic_craft_glnj.png';
import masonic_craft_glks from '../../assets/img/lodges/masonic_craft_glks.png';
import masonic_craft_glfl from '../../assets/img/lodges/masonic_craft_glfl.png';
import masonic_craft_glspr from '../../assets/img/lodges/masonic_craft_glspr.png';
import masonic_sr_srsj from '../../assets/img/lodges/masonic_sr_srsj.png';
import masonic_oes_tx_pha from '../../assets/img/lodges/masonic_oes_tx_pha.png';
import ahepa from '../../assets/img/lodges/ahepa.png';
import masonic_sr from '../../assets/img/lodges/masonic_sr.png';
import masonic_shrine from '../../assets/img/lodges/masonic_shrine.png';
import masonic_craft from '../../assets/img/lodges/masonic_craft.png';
import default_icon from '../../assets/img/lodges/masonic_craft.png';

export const copiriFetch = async (url, data = {}, headers = {}, method = 'POST') => {
	return fetch(url, {
		method: 'POST',
		credentials: 'same-origin',
		body: data
	});
};

axios.interceptors.request.use(
	function(config) {
		return config;
	},
	function(error) {
		// Do something with request error
		return Promise.reject(error);
	}
);

axios.interceptors.response.use(
	function(response) {
		let checkData = JSON.parse(localStorage.getItem('idiom'));
		let data = [];
		if (checkData) {
			data = checkData.ERR;
		}
		if (checkSiteUrlAccess() && checkSiteUrlAccess() === 'payments') {
			if (response?.status === 401 || response?.status === 440) {
				sessionLogout();
			}
		} else {
			if (response.data.status === 'LOGOUT' || response.status === 401 || response.status === 440) {
				if (localStorage.getItem('palaver') === null) {
				} else {
					toast.error(data['ERR007'] ? data['ERR007'] : '');
					localStorage.setItem('last_url_location', '/'); // eslint-disable-next-line
				}
				sessionLogout();
			}
		}
		return response;
	},
	function(error) {
		let checkLangData = JSON.parse(localStorage.getItem('idiom'));
		let langData = [];
		if (checkLangData) {
			langData = checkLangData.ERR;
		}
		if (checkSiteUrlAccess() && checkSiteUrlAccess() === 'payments') {
			if (error?.response?.status === 401 || error?.response?.status === 440) {
				sessionLogout();
			} else if (error?.response?.data?.result) {
				toast.error(error.response.data.result);
			} else {
				toast.error(checkLangData?.APY?.WLC?.WLC010);
			}
		} else {
			if (error.response.status === 401 || error.response.status === 440) {
				localStorage.setItem('last_url_location', '/'); // eslint-disable-next-line
				sessionLogout();
				toast.error(langData['ERR007'] ? langData['ERR007'] : '');
			}
		}
		return Promise.reject(error);
	}
);

export const copiriAxiosPost = async (url, data = {}, contentType = 'application/json') => {
	return await axios.post(
		url,
		data,
		{ withCredentials: true },
		{
			headers: {
				'Content-Type': contentType
			}
		}
	);
};

export const copiriPortalRequest = async (url, app_version, method, data = '', contentType = 'application/json') => {
	let token = localStorage.getItem('palaver');
	if (data !== '') {
		return await axios({
			method: method,
			url: config.api_url + '/v3' + url,
			data: data,
			withCredentials: true,
			headers: {
				Authorization: 'Bearer ' + token,
				'Content-Type': contentType
			}
		});
	} else {
		return await axios({
			method: method,
			withCredentials: true,
			url: config.api_url + '/v3' + url,
			headers: {
				Authorization: 'Bearer ' + token,
				'Content-Type': contentType
			}
		});
	}
};

export const copiriBankingPortalRequest = async (url, app_version, method, data = '', contentType = 'application/json') => {
	if (data !== '') {
		return await axios({
			method: method,
			url: config.api_url + '/v3' + url,
			data: data,
			withCredentials: true,
			headers: {
				'Content-Type': contentType
			}
		});
	} else {
		return await axios({
			method: method,
			withCredentials: true,
			url: config.api_url + '/v3' + url,
			headers: {
				'Content-Type': contentType
			}
		});
	}
};

export const copiriPortalBankingRequest = async (url, app_version, method, data = '', auth = false) => {
	let token = localStorage.getItem('palaver');
	if (auth) {
		return await axios({
			method: method,
			url: config.api_url + url,
			data: data,
			withCredentials: true,
			headers: {
				Authorization: 'Bearer ' + token,
				'Content-Type': 'application/json'
			}
		});
	} else {
		return await axios({
			method: method,
			url: config.api_url + url,
			data: data,
			withCredentials: true,
			headers: {
				'Content-Type': 'application/json'
			}
		});
	}
};

export const copiriAxiosGet = async url => {
	return await axios.get(
		url,
		{ withCredentials: true },
		{
			exposedHeaders: ['Set-Cookie'],
			headers: {
				'Content-Type': 'application/json'
			}
		}
	);
};

export const sessionLogout = async () => {
	if (checkSiteUrlAccess() && checkSiteUrlAccess() === 'payments') {
		let checkData = JSON.parse(localStorage.getItem('idiom'));
		if (checkData?.APY?.WLC) {
			let sessionData = checkData.APY.WLC;
			toast.error(sessionData['WLC011'] ? sessionData['WLC011'] : '');
		}
		setTimeout(() => (window.location.href = '/'), 1000);
	} else {
		localStorage.clear();
		let redirectURl = 'https://' + window.location.host + '/authentication/basic/login';
		setTimeout(() => (window.location.href = redirectURl), 500);
	}
};

export function checkValidation(str, type) {
	// eslint-disable-next-line
	const tiktokRegex = /^(https?:\/\/)?(www\.|vm\.)?tiktok\.com\/@[\w.-]+/;
	const threadsRegex = /^(https?:\/\/)?(www\.)?threads\.net\/@[\w.-]+/;
	let regexURL = new RegExp(
		'^(https?:\\/\\/)?' + // validate protocol
		'((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // validate domain name
		'((\\d{1,3}\\.){3}\\d{1,3}))' + // validate OR ip (v4) address
		'(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // validate port and path
		'(\\?[;&a-z\\d%_.~+=-]*)?' + // validate query string
			'(\\#[-a-z\\d_]*)?$',
		'i'
	); // validate fragment locator
	let regexEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	let regexPhone = /^[\d\s]+$/;

	//if type === url
	if (type === 'url') {
		return regexURL.test(str);
	}

	//if type === tiktok
	if (type === 'tiktok') {
		return tiktokRegex.test(str);
	}

	//if type === threads
	if (type === 'threads') {
		return threadsRegex.test(str);
	}

	//if type == email
	if (type === 'email') {
		return regexEmail.test(str);
	}

	//if type == phone
	if (type === 'phone') {
		return regexPhone.test(str);
	}
}

export function getLanguagePackUrl() {
	let url = '';
	let language_id = localStorage.getItem('shibboleth');
	url = '/languages/' + language_id + '/package/PRT';
	return url;
}

export function checkSiteUrlAccess() {
	//let site_url = localStorage.getItem('site_type');
	let site_url = '';
	if (/banking.copiri.com$/.test(window.location.hostname)) {
		site_url = 'banking';
	} else if (
		/ahepa.copiri.com$/.test(window.location.hostname) ||
		/pay.ahepa.app$/.test(window.location.hostname) ||
		/pay.ahe.pa$/.test(window.location.hostname)
	) {
		site_url = 'payments';
	} else if (/portal.copiri.com$/.test(window.location.hostname)) {
		site_url = 'portal';
	} else {
		site_url = 'portal'; // this will be for testing puprose.
	}

	return site_url;
}

/* function to return custom map icons */
export function getMarkerIcon(id, affiliation) {
	// eslint-disable-next-line
	var org_id = localStorage.getItem('selected_org_id'); // eslint-disable-next-line
	let url = ''; // eslint-disable-next-line
	if (1 == org_id) return (url = masonic_craft_gldc);
	// eslint-disable-next-line
	else if (3 == org_id) return (url = masonic_craft_glny);
	// eslint-disable-next-line
	else if (11 == org_id) return (url = masonic_craft_glnj);
	// eslint-disable-next-line
	else if (23 == org_id) return (url = masonic_craft_glks);
	// eslint-disable-next-line
	else if (29 == org_id) return (url = masonic_craft_glfl);
	// eslint-disable-next-line
	else if (10296 == org_id) return (url = masonic_craft_glspr);
	// eslint-disable-next-line
	else if (44837 == org_id) return (url = masonic_sr_srsj);
	// eslint-disable-next-line
	else if (50826 == org_id) return (url = masonic_oes_tx_pha);
	// eslint-disable-next-line
	else if (50276 == org_id) return (url = ahepa);
	// eslint-disable-next-line
	else if (21041801 == affiliation) return (url = masonic_sr);
	// eslint-disable-next-line
	else if (21041806 == affiliation) return (url = masonic_shrine);
	// eslint-disable-next-line
	else if (21041789 == affiliation) return (url = masonic_craft); // eslint-disable-next-line

	return (url = default_icon); // Default
}

export function checkPasswordValidation(newPassword, confirmPassword, pwdArr) {
	let pwd_arr = {};
	let regExpression = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[-+_!@#$%^&*.,?]).+$');
	pwd_arr['msg'] = '';
	pwd_arr['error'] = 0;
	if (newPassword.length < 10) {
		pwd_arr['msg'] = pwdArr['length'];
		pwd_arr['error'] = 1;
	}
	if (confirmPassword.length < 10) {
		pwd_arr['msg'] = pwdArr['length'];
		pwd_arr['error'] = 1;
	}
	if (newPassword.length >= 10 && confirmPassword.length >= 10) {
		if (!regExpression.test(newPassword)) {
			pwd_arr['msg'] = pwdArr['regular_expression'];
			pwd_arr['error'] = 1;
		} else {
		}
		if (regExpression.test(newPassword)) {
			if (newPassword !== confirmPassword) {
				pwd_arr['msg'] = pwdArr['pwd_not_match'];
				pwd_arr['error'] = 1;
			} else if (checkCharacterReccuring(newPassword)) {
				pwd_arr['msg'] = pwdArr['recurring_character'];
				pwd_arr['error'] = 1;
			} else {
			}
		}
	}
	return pwd_arr;
}

/* function to check if character repaet repeat three times */
function checkCharacterReccuring(string) {
	for (var i = 0; i < string.length; i++)
		if (string[i] === string[i + 1] && string[i + 1] === string[i + 2]) return true;
	return false;
}

/* function to get amount */
export function getTotalAmount(amount) {
	let return_amount = 0.0;
	let nf_options = { minimumFractionDigits: 2, maximumFractionDigits: 2 };
	return_amount = new Intl.NumberFormat('en-US', nf_options).format(amount);
	return return_amount;
}

const dateOnlyRegex = /^([0-9]([0-9]([0-9][1-9]|[1-9]0)|[1-9]00)|[1-9]000)(-(0[1-9]|1[0-2])(-(0[1-9]|[1-2][0-9]|3[0-1])))$/;

export function parseDateString(dateString) {
	if (dateOnlyRegex.test(dateString)) {
		const utcDate = new Date(dateString);
		const localDate = new Date(utcDate.getTime() + utcDate.getTimezoneOffset() * 60000);
		return localDate;
	}
	return new Date(dateString);
}

const options = {
	year: 'numeric',
	month: 'long',
	day: 'numeric'
};

export function getFormattedDate(dateString) {
	if (dateString) {
		if (dateOnlyRegex.test(dateString)) {
			const utcDate = new Date(dateString);
			const localDate = new Date(utcDate.getTime() + utcDate.getTimezoneOffset() * 60000);
			let return_date = localDate.toLocaleDateString('en-US', options);
			return return_date;
		}
		return new Date(dateString);
	}
}

// return one dimensional array of array objects
export function convertArrayObjectsToArray(data) {
	return data.map(item => {
		// Get all keys of the current object.
		// Since each object is guaranteed to have only one key, we take the first one.
		const key = Object.keys(item)[0];
		// Return the value associated with that key.
		return item[key];
	});
}

/* function to get list array */
export function txLanguageArray(content) {
	let returnListArr = [];
	if (content && Array.isArray(content) && content.length > 0) {
		returnListArr = content;
	}
	return returnListArr;
}

/* function to convert base64 image to file */
export function base64ToFileSync(base64String, filename) {
  // Split the Data URI to separate the metadata from the raw base64 data
  const arr = base64String.split(',');
  const mime = arr[0].match(/:(.*?);/)[1]; // Extract mime type (e.g., image/png)
  const bstr = atob(arr[1]);               // Decode base64 string
  
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  
  // Populate the typed array with byte values
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  
  // Create and return the File object
  return new File([u8arr], filename, { type: mime });
}

// function to decode HTML entities safely
export function decodeHTMLEntities(str) {
  if (!str) return '';
  const parser = new DOMParser();
  const doc = parser.parseFromString(str, 'text/html');
  return doc.documentElement.textContent;
};

